import {
  cilBuilding,
  cilDescription,
  cilFactory,
  cilFastfood,
  cilInfo,
  cilSettings,
  cilSpeedometer,
  cilTruck,
  cilUser,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import { CNavItem } from '@coreui/react'
import { faFish } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { scopes } from 'src/components/auth/permissionsMap'

const _nav = [
  {
    component: CNavItem,
    name: 'Dashboard',
    to: '/app/dashboard',
    scopes: [scopes.products.read],
    icon: <CIcon icon={cilSpeedometer} customClassName="nav-icon" />,
    // badge: {
    //   color: 'info',
    //   text: 'NEW',
    // },
  },
  {
    component: CNavItem,
    name: 'Products',
    to: '/app/products',
    scopes: [scopes.products.read],
    icon: <CIcon icon={cilFastfood} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Admin',
    to: '/app/admin',
    scopes: [scopes.admin.read],
    icon: <CIcon icon={cilSettings} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Manufacturers',
    to: '/app/manufacturers',
    scopes: [scopes.manufacturers.read],
    icon: <CIcon icon={cilBuilding} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Sites',
    to: '/app/sites',
    scopes: [scopes.sites.read],
    icon: <CIcon icon={cilFactory} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Platforms',
    to: '/app/platforms',
    scopes: [scopes.platforms.read],
    icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Consignments',
    to: '/app/consignments',
    scopes: [scopes.consignments.read],
    icon: <CIcon icon={cilTruck} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Catch Certificates',
    to: '/app/tools/catch',
    scopes: [scopes.catchcertificates.verify],
    icon: <FontAwesomeIcon icon={faFish} className="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Users',
    to: '/app/users',
    scopes: [scopes.users.read],
    icon: <CIcon icon={cilUser} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Attestations',
    to: '/app/attestations',
    scopes: [scopes.attestation.read],
    icon: <CIcon icon={cilDescription} customClassName="nav-icon" />,
  },
  {
    component: CNavItem,
    name: 'Guides',
    to: '/app/userguides',
    scopes: [scopes.userguides.read],
    icon: <CIcon icon={cilInfo} customClassName="nav-icon" />,
  },
]

export default _nav
